export const formatDate = (date) => {
  if (!date) return null;
  const d = new Date(date);
  return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
}

export const getYearList = (startYear = 2014, endYear = new Date().getFullYear()) => {
  return [
    ...Array(endYear - 1 - startYear + 1)
      .fill()
      .map((_, idx) => ({
        index: idx,
        id: (startYear + idx).toString(),
        value: (startYear + idx).toString(),
        label: (startYear + idx).toString(),
        checked: false
      }))
  ].reverse();
}